import React, { ReactPortal, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  /**
   * Children nodes
   */
  children: React.ReactNode;
}

const Portal = ({ children }: PortalProps): ReactPortal => {
  const el = useRef(null);
  const [, setMounted] = useState(false);

  useEffect(() => {
    el.current = document.createElement('div');
    el.current.setAttribute('data-testid', 'dynamic-portal');
    el.current.style.position = 'absolute';
    el.current.style.top = 0;
    el.current.style.left = 0;
    document.body.appendChild(el.current);
    setMounted(true);

    return () => {
      el.current.remove();
    };
  }, []);

  return el.current ? createPortal(children, el.current) : null;
};

export default Portal;
